export default "__VITE_ASSET__DXKT7WKR__"